module.exports = __webpack_public_path__ + "static/img/313.aff4e08.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/190926/313.jpg
// module id = 61En
// module chunks = 0